import { Tooltip } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { BulkOrderStatus, type FixingOrderError, type StopLossOrderError } from '@/store/bulkOrder/state.ts';

type OrderStatusProps = {
  status: BulkOrderStatus | undefined;
  errors: (StopLossOrderError | FixingOrderError)[] | undefined;
};

export const OrderStatus = (props: OrderStatusProps) => {
  const { status, errors } = props;

  switch (status) {
    case BulkOrderStatus.IDLE:
      return (
        <span className="badge badge-md rounded-pill badge-secondary">
          <FormattedMessage id="status.idle" />
        </span>
      );

    case BulkOrderStatus.VALIDATING:
      return (
        <span className="badge badge-md rounded-pill badge-info">
          <FormattedMessage id="status.validating" />
        </span>
      );

    case BulkOrderStatus.VALID:
      return (
        <span className="badge badge-md rounded-pill badge-warning">
          <FormattedMessage id="status.valid" />
        </span>
      );

    case BulkOrderStatus.INVALID:
      if (errors?.length === 0) {
        return (
          <span className="badge badge-md rounded-pill badge-danger">
            <FormattedMessage id="status.invalid" />
          </span>
        );
      }

      return (
        <Tooltip
          color="danger"
          contents={
            <div>
              {errors?.map((error, errorIndex) => (
                <>
                  <div key={error.field}>{error.message}</div>
                  {errorIndex < errors.length - 1 && <br key={error.field} />}
                </>
              ))}
            </div>
          }
        >
          <span className="badge badge-md rounded-pill badge-danger">
            <FormattedMessage id="status.invalid" />
          </span>
        </Tooltip>
      );

    case BulkOrderStatus.PENDING:
      return (
        <span className="badge badge-md rounded-pill badge-warning">
          <FormattedMessage id="status.pending" />
        </span>
      );

    case BulkOrderStatus.SUCCESS:
      return (
        <span className="badge badge-md rounded-pill badge-success">
          <FormattedMessage id="status.success" />
        </span>
      );

    case BulkOrderStatus.FAILED:
      return (
        <span className="badge badge-md rounded-pill badge-danger">
          <FormattedMessage id="status.failed" />
        </span>
      );
  }

  return <div>OrderStatus</div>;
};
